import React from 'react';
import { IDropdownItem, ISelectProps, Omit, Select } from '../../../../../ui';
import { withTranslate } from '../../../../shared/i18n/translate';

interface IPoiAreaSelectProps extends Omit<ISelectProps, 'items'> {
	areas: string[];
}

export const PoiAreaSelect = withTranslate<IPoiAreaSelectProps>(
	({ t, areas, ...rest }) => {
		const all = {
			type: 'item' as const,
			value: 'All',
		};

		const items: IDropdownItem[] = [all, ...areas];

		const areaToString = (item: IDropdownItem | null) =>
			typeof item === 'string' ? item : t('shop_dine_all_areas');

		return (
			<Select
				items={items}
				itemToString={areaToString}
				initialSelectedItem={all}
				{...rest}
			/>
		);
	},
);
